<template>
    <div class="card">
        <div class="card-header">
            <p class="card-header-title">
                {{ trans.element.edit_base }}
            </p>
        </div>
        <div class="card-content">

            <div class="notification is-success has-text-centered" v-show="success">
                <button class="delete" @click="success = false"></button>
                {{ trans.msg.success }}
            </div>

            <form method="POST" :action="action" @submit.prevent="submit($event, actions.edit)"
                  @input="clearValidation" novalidate
            >
                <slot><!--CSRF--></slot>

                <div class="field is-horizontal is-required">
                    <label for="name" class="field-label is-normal">
                        {{ trans.element.name }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <input id="name" v-model="form.name"
                                       class="input" :class="[errors.name ? 'is-danger' : '']"
                                       type="text" name="name" required
                                >
                            </div>
                            <p v-show="errors.name" class="help is-danger">
                                {{ errors.name }}
                            </p>
                        </div>
                    </div>

                </div>

                <div class="field is-horizontal">
                    <label for="description" class="field-label is-normal">
                        {{ trans.element.description }}
                    </label>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <textarea id="description" v-model="form.description"
                                          class="textarea" :class="[errors.description ? 'is-danger' : '']"
                                          name="description" required
                                ></textarea>
                            </div>
                            <p v-show="errors.description" class="help is-danger">
                                {{ errors.description }}
                            </p>
                        </div>
                    </div>
                </div>

                <div class="field is-horizontal">
                    <div class="field-label"></div>
                    <div class="field-body">
                        <div class="field">
                            <div class="control">
                                <button type="submit" class="button is-info"
                                        :class="[isLoading ? 'is-loading' : '']"
                                        :disabled="isLoading"
                                >
                                    {{ trans.element.save }}
                                </button>
                                <button type="button" class="button"
                                    @click="moveBack"
                                >
                                    {{ trans.element.cancel }}
                                </button>
                                <button
                                    v-if="is_can_delete"
                                    type="button"
                                    class="button is-pulled-right is-danger is-outlined"
                                    @click="showDeleteBaseModal(base)"
                                >
                                    {{ trans.element.delete }}
                                </button>
                            </div>
                        </div>
                        <p v-show="errors.unexpected" class="help is-danger">
                            {{ errors.unexpected }}
                        </p>
                    </div>
                </div>

                <div class="content mt-1" v-if="!isAdmin24Base">
                    <hr />
                    <license-key-template :base="base"></license-key-template>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
    import {axiosForm} from '../mixins/axiosFormMixin';
    import {mapActions, mapState} from "vuex";

    export default {
        mixins: [axiosForm],
        props: {
            base: Object,
            trans: Object,
            modal_trans: Object,
            actions: Object,
            previous_page: String,
            is_can_delete: Boolean,
            portal_type: String,
        },
        data() {
            return {
                success: false,
                form: {
                    name: this.base.name,
                    description: this.base.description
                },

                okReport: 'База успешно отредактирована',
                failReport: 'Ошибка редактирования базы',
            }
        },
        methods: {
            ...mapActions('baseList',
                [
                    'setBaseList',
                    'addStateData',
                    'showDeleteBaseModal',
                ]
            ),
            postResultHandler(response) {
                this.moveBack();
            },
            moveBack() {
                window.location.replace(this.previous_page);
            }
        },
        computed: {
            ...mapState('baseList', [
                'bases'
            ]),
            isAdmin24Base() {
                return this.portal_type == 'admin24';
            }
        },
        created() {
            this.setBaseList([this.base]);

            let storeData = {
                trans: this.modal_trans,
                actions: this.actions
            };

            this.addStateData(storeData);
        },
        watch: {
            bases() {
                let baseDeleted = !this.bases.length;

                if (baseDeleted) this.moveBack();
            }
        }
    }
</script>
